import { useState } from 'react';
import { ReactionsDisplayManager } from 'features/room-reactions/utils/ReactionsDisplayManager';

export const useReactionsDisplayManager = () => {
  const [manager] = useState(() => new ReactionsDisplayManager());

  return manager;
};
